import { Box, Chip, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

// One exam in the list. The card grows with its content — the old fixed
// 150x178 square clipped the mark and the teacher line.
const SubjectCard = ({ i, data }) => {
  const currentUser = useSelector((s) => s.user).currentUser;
  const inProgress =
    currentUser?.is_attempting === true && data?.id === currentUser?.current_exam_id;

  const max = Number(data?.exam_score) || 0;
  const got = Number(data?.user_score) || 0;
  const corrected = Boolean(data?.correction_status);
  const ratio = max > 0 ? got / max : 0;
  const tone = ratio >= 0.8 ? "#0E9F6E" : ratio >= 0.5 ? "#D97706" : "#DC2626";

  const owner = data?.owner;
  const ownerLine = owner
    ? [owner.subject, owner.class, owner.school].filter(Boolean).join(" · ")
    : "";

  return (
    <Link
      to={`/exams/${data?.id}`}
      className="card-animation"
      style={{ animationDelay: `0.${i}s`, height: "fit-content" }}
    >
      <Stack
        sx={{
          width: { xs: "100%", sm: "218px" },
          padding: "18px 16px 16px",
          borderRadius: "18px",
          background: "#fff",
          border: "1px solid rgba(15,23,42,.08)",
          boxShadow: "0 1px 2px rgba(15,23,42,.04), 0 10px 26px rgba(15,23,42,.05)",
          transition: "transform .18s ease, box-shadow .18s ease, border-color .18s ease",
          "&:hover": {
            transform: "translateY(-3px)",
            borderColor: "rgba(37,99,235,.35)",
            boxShadow: "0 1px 2px rgba(15,23,42,.04), 0 18px 38px rgba(37,99,235,.14)",
          },
        }}
      >
        <Box sx={{ minHeight: "24px" }}>
          {inProgress && (
            <Chip color="primary" size="small" label={t("in_progress")} sx={{ fontSize: "0.7rem" }} />
          )}
        </Box>

        <Box
          sx={{
            width: "58px",
            height: "58px",
            margin: "6px auto 12px",
            borderRadius: "18px",
            display: "grid",
            placeItems: "center",
            background: "linear-gradient(135deg,#2563EB,#7C3AED)",
            boxShadow: "0 8px 18px rgba(37,99,235,.28)",
          }}
        >
          <img src="/assets/icons/file.svg" width={20} alt="" />
        </Box>

        <Typography
          className="text-ellipsis-2"
          sx={{ textAlign: "center", fontWeight: 800, color: "text.primary", minHeight: "3em" }}
        >
          {data?.title}
        </Typography>

        {data?.is_attempted && corrected && max > 0 && (
          <Typography sx={{ textAlign: "center", fontWeight: 800, color: tone, marginTop: "6px" }}>
            {got} / {max} · {Math.round(ratio * 100)}%
          </Typography>
        )}

        {owner && (
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "0.72rem",
              color: "text.secondary",
              marginTop: "8px",
              paddingTop: "8px",
              borderTop: "1px solid rgba(15,23,42,.06)",
              lineHeight: 1.7,
            }}
          >
            👨‍🏫 {owner.teacher}
            {ownerLine && <><br />{ownerLine}</>}
          </Typography>
        )}
      </Stack>
    </Link>
  );
};

export default SubjectCard;
